import React from 'react'
import SweetAlert from 'react-bootstrap-sweetalert'
import { ToastContainer, toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import instance from '../../axios';
import { useState } from 'react';
import { useSelector } from 'react-redux';
import { useParams } from 'react-router';

function Help(props) {
  // ads id
  // user id
  // amount

  const [quantity, setQuantity] = useState("");
  const [inputDescription, setInputDescription] = useState("");
  const [error, setError] = useState(false);
  const [success, setSuccess] = useState(false);
  const [emptyForm, setEmptyForm] = useState(false);
  const [isLoading, setIsLoading] = useState(false);

  const { currentUser } = useSelector((state) => state.user);

  const { id } = useParams();

  const notify = (status) => {
    switch (status) {
      case "success":
        toast.success("Muvaffaqiyatli qo'shildi", {
          position: "top-right",
          autoClose: 5000,
          hideProgressBar: false,
          closeOnClick: true,
          pauseOnHover: true,
          draggable: true,
          progress: undefined,
        });
        break;

      case "error":
        toast.error("Hatolik yuz berdi!", {
          position: "top-right",
          autoClose: 5000,
          hideProgressBar: false,
          closeOnClick: true,
          pauseOnHover: true,
          draggable: true,
          progress: undefined,
        });
        break;

      case "warning":
        toast.warn("Qayta urinib ko'ring!", {
          position: "top-right",
          autoClose: 5000,
          hideProgressBar: false,
          closeOnClick: true,
          pauseOnHover: true,
          draggable: true,
          progress: undefined,
        });
        break;

      default:
        return;
    }
  };

  const handleTimeOut = () => {
    setTimeout(() => {
      setError(false);
      setSuccess(false);
      setEmptyForm(false);
    }, 5000);
  };

  const emptySubmittedForm = () => {
    setQuantity("");
    setInputDescription("");
  };

  const handleFormSubmit = (e) => {
    e.preventDefault();
    setIsLoading(true);

    const help = {
      ad_id: id,
      user_id: currentUser?.id,
      amount: quantity,
      text: inputDescription,
    };

    if (help.ad_id && help.amount && help.user_id) {
      instance
        .post(`api/reqs`, help)
        .then((res) => {
          notify("success");
          setIsLoading(false);
        })
        .catch((err) => {
          notify("error");
          setIsLoading(false);
          setError(true);
        })
        .finally(() => {
          setIsLoading(false);
          emptySubmittedForm();
          handleTimeOut();
        });
    } else {
      setIsLoading(false);
      notify("warning");
    }
  };      
  return (
      <SweetAlert
      show={props.show}
      confirmBtnStyle={{ display: "none" }}
      // showCancel
      title="alert"
      onCancel={props.oncancel}>
      <ToastContainer />
      <div className="container mx-auto p-2">
        <div className="relative pt-2">
          <div className="max-w-2xl mx-auto">
            <form className="admin-form" onSubmit={handleFormSubmit}>
              <div className="relative z-0 mb-6 w-full group">
                <input
                  type="number"
                  name="floating_password"
                  id="floating_password"
                  className="block py-2.5 px-0 w-full text-sm text-gray-900 bg-transparent border-0 border-b-2 border-gray-300 appearance-none dark:border-gray-600 dark:focus:border-blue-500 focus:outline-none focus:ring-0 focus:border-blue-600 peer"
                  placeholder=" "
                  required
                  onChange={(e) => setQuantity(e.target.value)}
                  value={quantity}
                />
                <label
                  // for="floating_password"
                  className="absolute text-sm text-gray-500 dark:text-gray-400 duration-300 transform -translate-y-6 scale-75 top-3 -z-10 origin-[0] peer-focus:left-0 peer-focus:text-blue-600 peer-focus:dark:text-blue-500 peer-placeholder-shown:scale-100 peer-placeholder-shown:translate-y-0 peer-focus:scale-75 peer-focus:-translate-y-6">
                  Miqdori
                </label>
              </div>

              <div className="max-w-2xl mx-auto mb-10">
                <textarea
                  id="message"
                  rows="4"
                  className="block p-2.5 w-full text-sm text-gray-900 bg-gray-50 rounded-lg border border-gray-300 focus:ring-blue-500 focus:border-blue-500 dark:border-gray-600 dark:focus:ring-blue-500 dark:focus:border-blue-500"
                  placeholder="Qo’shimcha malumotlar..."
                  onChange={(e) => setInputDescription(e.target.value)}
                  value={inputDescription}></textarea>
              </div>
              <button
                type="submit"
                className="text-white block bg-blue-700 hover:bg-blue-800 focus:ring-4 focus:ring-blue-300 font-medium rounded-lg text-sm w-full sm:w-auto px-5 py-2.5 text-center dark:bg-blue-600 dark:hover:bg-blue-700 dark:focus:ring-blue-800">
                Tasdiqlash
              </button>
            </form>
          </div>
        </div>

        {isLoading ? (
          <h1 className="mt-4 font-bold">Yuklanmoqda...</h1>
        ) : error ? (
          <h1 className="mt-4 text-red-600 font-bold">
            Xatolik yuz berdi. Qayta urinib ko'ring!
          </h1>
        ) : emptyForm ? (
          <h1 className="mt-4 text-red-600 font-">Bo’sh forma yozing!</h1>
        ) : success ? (
          <h1 className="mt-4 text-green-600 font-bold">
            E'lon muvaffaqiyatli yuklandi!
          </h1>
        ) : (
          ""
        )}
      </div>
    </SweetAlert>
  )
}

export default Help